import * as React from "react";
import { subscribeSessionExpired, wasSessionExpiredNotified } from "@/lib/session/sessionExpired";
import { useTranslation } from "react-i18next";

/**
 * Fullscreen overlay shown when the widget's backend session expires.
 * Uses simple inline styles for shadow DOM isolation.
 */
export function WidgetSessionExpiredOverlay() {
    const { t } = useTranslation();
    const [show, setShow] = React.useState(wasSessionExpiredNotified());

    React.useEffect(() => {
        return subscribeSessionExpired(() => setShow(true));
    }, []);

    if (!show) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(4px)",
                padding: "24px",
                textAlign: "center",
            }}
        >
            <div
                style={{
                    maxWidth: "320px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                <h2
                    style={{
                        margin: 0,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#1a1a1a",
                    }}
                >
                    {t("widget.session.expired_title", "Session expired")}
                </h2>
                <p
                    style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "#666",
                        lineHeight: 1.5,
                    }}
                >
                    {t("widget.session.expired_description", "Please refresh the page to continue booking.")}
                </p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        marginTop: "8px",
                        padding: "12px 24px",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#fff",
                        backgroundColor: "#2563eb",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        transition: "background-color 0.15s",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#1d4ed8")}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#2563eb")}
                >
                    {t("widget.session.refresh", "Refresh page")}
                </button>
            </div>
        </div>
    );
}
